import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "transcribe_job_name", label: "transcribe_job_name" },
    { key: "transcript_language", label: "transcript_language" },
    { key: "num_segments", label: "num_segments" }
  ],
};

export default schema;

